module.exports = __webpack_public_path__ + "static/img/apps.be91792a.svg";